import { Component } from "react";

export abstract class DynamicForm<P, S> extends Component<P, S> {
  abstract onSubmit: () => Promise<void>;
  abstract onDisableSubmitButton: () => boolean;
}
